'use strict';

var SoaCollection = require('bunsen/collections/SoaCollection');
module.exports = SoaCollection.extend({});

Object.assign(module.exports.prototype, {
    model: require('bunsen/models/inventory/Listing')
});



// WEBPACK FOOTER //
// ./~/bunsen/collections/inventory/Listings.es.js